import styles from './index.module.scss';
const Arrow = (props) => {
    const { className, ...otherProps } = props;
    return (
        <div className={`${styles.container} ${className}`} {...otherProps}>
            {/* 箭头 SVG */}
            <svg width="37" height="56" viewBox="0 0 37 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    className={`${styles.arrow} ${styles.arrow1}`}
                    d="M22.5382 26.2894C23.1571 27.0113 23.1571 28.0767 22.5382 28.7986L4.42305 49.9302C3.69692 50.7772 2.35204 49.9194 2.814 48.9038L12.3484 27.9438C12.4637 27.6902 12.4637 27.3992 12.3484 27.1456L2.81375 6.18502C2.3518 5.16948 3.69665 4.31162 4.42279 5.15863L22.5382 26.2894Z"
                    fill="#8CB2FF"
                />
                <path
                    className={`${styles.arrow} ${styles.arrow2}`}
                    d="M36.1511 26.5461C36.6349 27.0904 36.635 27.9107 36.1511 28.455L20.315 46.2711C19.7637 46.8913 18.7744 46.238 19.1284 45.4875L27.4672 27.8076C27.5588 27.6135 27.5588 27.3887 27.4672 27.1947L19.1282 9.51441C18.7743 8.76392 19.7635 8.11056 20.3148 8.73073L36.1511 26.5461Z"
                    fill="#B5D0FF"
                />
            </svg>
        </div>
    );
};

export default Arrow;
